// Action creators

var initiateConnection = (connection) => {
  return function (dispatch) {
    dispatch({ type: "INITIATE_CONNECTION", payload: { 'connection': connection } });
  };
}

export default { 'INITIATE_CONNECTION': initiateConnection };


// WEBPACK FOOTER //
// ./src/actions/connection_actions.js